export default {
  common: {
    back: 'Retour',
    contact: 'Contact',
    email: 'support@wedora.fr',
    privacyEmail: 'privacy@wedora.fr',
  },
  termsOfService: {
    title: 'Conditions d\'utilisation',
    sections: {
      introduction: {
        title: '1. Introduction',
        content: 'Bienvenue sur Wedora. En utilisant notre service, vous acceptez de respecter ces conditions d\'utilisation. Veuillez les lire attentivement avant d\'utiliser notre plateforme.',
      },
      description: {
        title: '2. Description du Service',
        content: 'Wedora est une plateforme de planification de mariage qui permet aux couples de :',
        features: [
          'Gérer leur liste d\'invités',
          'Suivre leur budget',
          'Organiser leurs tâches',
          'Créer leur site de mariage',
          'Communiquer avec leurs prestataires',
        ],
      },
      accounts: {
        title: '3. Comptes Utilisateurs',
        content: 'Pour utiliser Wedora, vous devez créer un compte. Vous êtes responsable de maintenir la confidentialité de vos identifiants et de toutes les activités qui se produisent sous votre compte.',
      },
      usage: {
        title: '4. Utilisation du Service',
        content: 'En utilisant notre service, vous acceptez de :',
        rules: [
          'Ne pas utiliser le service à des fins illégales',
          'Ne pas tenter de compromettre la sécurité du service',
          'Ne pas partager de contenu inapproprié ou offensant',
          'Respecter les droits des autres utilisateurs',
        ],
      },
      intellectual: {
        title: '5. Propriété Intellectuelle',
        content: 'Tout le contenu présent sur Wedora, incluant mais non limité aux textes, graphiques, logos, et code source, est la propriété de Wedora ou de ses partenaires et est protégé par les lois sur la propriété intellectuelle.',
      },
      modifications: {
        title: '6. Modifications des Conditions',
        content: 'Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications prendront effet dès leur publication sur le site. Votre utilisation continue du service après ces modifications constitue votre acceptation des nouvelles conditions.',
      },
      contact: {
        title: '7. Contact',
        content: 'Pour toute question concernant ces conditions d\'utilisation, veuillez nous contacter à l\'adresse : support@wedora.fr',
      },
    },
  },
  privacyPolicy: {
    title: 'Politique de confidentialité',
    sections: {
      introduction: {
        title: '1. Introduction',
        content: 'Chez Wedora, nous accordons une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations.',
      },
      dataCollection: {
        title: '2. Collecte des Données',
        content: 'Nous collectons les informations suivantes :',
        types: [
          'Informations de profil (nom, prénom, email)',
          'Informations sur votre mariage (date, lieu)',
          'Liste des invités',
          'Informations de budget',
          'Préférences de personnalisation',
        ],
      },
      dataUsage: {
        title: '3. Utilisation des Données',
        content: 'Nous utilisons vos données pour :',
        purposes: [
          'Fournir et améliorer nos services',
          'Personnaliser votre expérience',
          'Communiquer avec vous concernant votre compte',
          'Envoyer des notifications importantes',
          'Analyser et améliorer nos services',
        ],
      },
      dataProtection: {
        title: '4. Protection des Données',
        content: 'Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données contre tout accès, modification, divulgation ou destruction non autorisés. Vos données sont stockées sur des serveurs sécurisés et sont chiffrées lors de leur transmission.',
      },
      dataSharing: {
        title: '5. Partage des Données',
        content: 'Nous ne vendons jamais vos données personnelles à des tiers. Nous pouvons partager certaines informations avec nos prestataires de services qui nous aident à exploiter notre plateforme, sous réserve d\'obligations strictes de confidentialité.',
      },
      rights: {
        title: '6. Vos Droits',
        content: 'Conformément au RGPD, vous disposez des droits suivants :',
        list: [
          'Droit d\'accès à vos données',
          'Droit de rectification',
          'Droit à l\'effacement',
          'Droit à la portabilité des données',
          'Droit d\'opposition au traitement',
        ],
      },
      cookies: {
        title: '7. Cookies',
        content: 'Nous utilisons des cookies pour améliorer votre expérience sur notre plateforme. Vous pouvez contrôler l\'utilisation des cookies via les paramètres de votre navigateur.',
      },
      contact: {
        title: '8. Contact',
        content: 'Pour toute question concernant notre politique de confidentialité ou pour exercer vos droits, veuillez nous contacter à l\'adresse : privacy@wedora.fr',
      },
    },
  },
}; 